import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import SearchBoxClass from "../forms/search-box";

const { number, string, func, oneOf, bool } = PropTypes;
const SearchBox = React.createFactory(SearchBoxClass);

export default class extends React.Component {
  static displayName = "ArrowSelect";

  static propTypes = {
    type: oneOf(["text", "search"]),
    placeholder: string,
    selectedIndex: number,
    maxIndex: number,
    onType: func,
    onEnter: func,
    onArrow: func,
    onEscape: func,
    onEmpty: func,
    onFocus: func,
    onBlur: func,
    focusOnMount: bool,
  };

  handleKeyPress = evnt => {
    switch (evnt.key) {
      case "ArrowUp":
        evnt.preventDefault();
        return typeof this.props.onArrow === "function"
          ? this.props.onArrow(Math.max(this.props.selectedIndex - 1, 0))
          : undefined;
      case "ArrowDown":
        evnt.preventDefault();
        return typeof this.props.onArrow === "function"
          ? this.props.onArrow(Math.min(this.props.selectedIndex + 1, this.props.maxIndex))
          : undefined;
      case "Enter":
        evnt.preventDefault();
        return typeof this.props.onEnter === "function" ? this.props.onEnter() : undefined;
      case "Escape":
        return typeof this.props.onEscape === "function" ? this.props.onEscape(evnt) : undefined;
      default:
        if (evnt.key !== "Shift") {
          const query = evnt.currentTarget.value;
          return typeof this.props.onType === "function" ? this.props.onType(query, evnt) : undefined;
        }
    }
  };

  handleKeyDown = evnt => {
    const query = this.arrowSelectInput != null ? this.arrowSelectInput.value : undefined;
    if (_.isEmpty(query) && evnt.key === "Backspace") {
      return typeof this.props.onEmpty === "function" ? this.props.onEmpty() : undefined;
    }
  };

  render() {
    if (this.props.type === "search") {
      return SearchBox({
        ref: e => {
          return (this.arrowSelectInput = e);
        },
        className: this.props.className,
        placeholder: this.props.placeholder,
        defaultValue: this.props.defaultValue,
        focusOnMount: this.props.focusOnMount,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        onKeyDown: this.handleKeyDown,
        onKeyUp: (value, e) => {
          return this.handleKeyPress(e);
        },
      });
    } else {
      return (
        <input
          type="text"
          ref="arrowSelectInput"
          className={this.props.className}
          placeholder={this.props.placeholder}
          defaultValue={this.props.defaultValue}
          onKeyUp={this.handleKeyPress}
          onKeyDown={this.handleKeyDown}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
        />
      );
    }
  }
}
